import React, {useState } from 'react';
import IMAGES from '@/public/assets/img'
import { SEODATA } from '@/config/seo_config';
import Image from 'next/image';
import Head from 'next/head';
import BuyerEligibilityForm from '@/component/shared/termsheetForm/BuyerEligibility';
import Personaldetails from '@/component/shared/termsheetForm/Personaldetails';
import ExporterCredlix from '@/component/shared/termsheetForm/ExporterCredlix';
import ExporterRisk from '@/component/shared/termsheetForm/ExporterRisk';
import HowWork from '@/component/shared/termsheetForm/HowWork';
import CreditCheck from '@/component/shared/termsheetForm/CreditCheck';
import GetStarted from '@/component/shared/termsheetForm/GetStarted';
import ExportTrustSection from '@/component/shared/termsheetForm/ExportTrustSection';
import DataSecurity from '@/component/shared/termsheetForm/DataSecurity';
import Slider from '@/component/shared/businessLoansPages/Slider';
import { FormProviderBuyer } from '@/component/shared/termsheetForm/FormContext';


export const metadata = {
  title: SEODATA.TERMSHEET.title,
  description: SEODATA.TERMSHEET.description,
  alternates: {
    canonical: SEODATA.TERMSHEET.url
  },
  
  openGraph: {
    title: SEODATA.TERMSHEET.title,
    description: SEODATA.TERMSHEET.description,
    url: SEODATA.TERMSHEET.url,
  }
};
const slidesData = [
    {
      id: 1,
      content: "We significantly improved our suppliers' cash cycle, allowing efficient invoice-to-cash processing",
      name: "Aditya Birla",
      position: "Aditya Birla || Fashion & Retail",
    },
    {
      id: 2,
      content: "Their understanding and knowledge of financing solutions have been valuable for our business.",
      name: "Deepak Gaur Sharma",
      position: "MD || Accord",
    },
    {
      id: 3,
      content: "Manufacturing company automates supply chain financing",
      name: "Ishita Bowry",
      position: "Director - Finance || TwigaFiber",
    },
    {
      id: 4,
      content: "The entire process of working with the Credlix team has been easy and end-to-end digital.",
      name: "Ujwal Desai",
      position: "CEO & Founder || Lucro",
    },
    {
      id: 5,
      content: "Food processing company adds significant value to its supply chain",
      name: "Vinod Jobanputra",
      position: "CEO & Founder || Lalsai Dehy Foods",
    },
  ]

const BuyerCreditCheck = () => {
  
    const [showNextStep, setShowNextStep]= useState(false);
    const showSteps=()=>{
        setShowNextStep(true)
    }
    const showFirstStep=()=>{
      setShowNextStep(false)
    }

    return (
        <main>

            <Head>  
            <title>{metadata.title}</title>
            <meta name="description" content={metadata.description} />
            {/* OpenGraph tags */} 
            <meta property="og:title" content={metadata.openGraph.title} />
            <meta property="og:description" content={metadata.openGraph.description} />
            <meta property="og:url" content={metadata.openGraph.url} />
            <link rel="canonical" href={metadata.alternates.canonical} />
            </Head>
            <section className={`relative bg-no-repeat sm:bg-center bg-cover bg-bottom`} style={{backgroundImage:`url(${IMAGES.termsheet.BackgroundBanner.src})`}}>
                <div className='container xm:px-2 px-3 mt-[110px]'>
                    <div className='flex flex-wrap gap-4 sm:flex-col'>
                    <div className='w-1/2 sm:w-full pt-12 md:pb-5'>
                    <h1 className="text-heading5 leading-[50px] text-[#072F5F]  sm:text-xl font-medium">
                    KNOW BEFORE <span className='text-[#086AC9]'>YOU TRADE!</span>
                    </h1>
                    <p className='text-base2 font-normal text-[#3C3C3C] sm:text-base'>Get detailed creditworthiness report  quickly and securely.​</p>
                    <div className="relative w-full max-w-md mt-6">
                    <Image src={IMAGES.termsheet.ManTerms} width={336} height={327} alt='Man Image' priority className='sm:h-[260px] sm:w-[230px]'/>
                    <div className="absolute right-[-24px] bottom-[-33px] sm:right-[-20px] w-[224px]  sm:bottom-[-27px]">
                    <Image src={IMAGES.termsheet.RiskMeter} width={224} height={250} alt='Risk Meter' className='sm:h-[190px] sm:w-[170px]'/>
                    </div>
                    </div>
                    </div>
                    <div className='w-[47%] sm:w-full pt-12 pb-10'>
                    <FormProviderBuyer>
                    {!showNextStep ?
                    <BuyerEligibilityForm showStep1={showSteps} />:
                      <Personaldetails showPrevStep={showFirstStep} formType="GetInTouchNew" />
                    }
                    </FormProviderBuyer>
                    </div>
                    </div>
                </div>
            </section>
            <HowWork />            
            <ExporterCredlix />
            <ExporterRisk />
            <CreditCheck />
            <section className="bg-[#F0F7FF] py-[100px] sm:pb-10">
          <div className="mx-auto w-full container">
            <div className="max-w-[1280px] mx-auto w-full">
              <div className="flex items-center justify-between sm:flex-col w-full">
              <div className="w-[30%] sm:w-full">
                <h2 className="text-xxl text-[#1A1A1A] font-bold mb-3">Real-World Impact: Success Stories​</h2>
                <p className="text-base2 text-[#1A1A1A]"> Real stories from real clients showcasing their journey with us</p>
              </div>
              <div className="w-[65%] sm:w-full sm:mt-3">
                <Slider slides={slidesData}/>
              </div>
              </div>
            </div>
          </div>
        </section>
            <DataSecurity />
            <ExportTrustSection />
            <GetStarted />

        </main>
    );
};

export default BuyerCreditCheck;

